import React from "react";
import { FAQItem } from "./types";

interface FAQExportProps {
  items?: FAQItem[];
  backgroundColor?: string;
  textColor?: string;
  accentColor?: string;
  borderRadius?: number;
  padding?: number;
  questionFontSize?: number;
  answerFontSize?: number;
  textAlign?: "left" | "center" | "right";
  allowMultiple?: boolean;
}

export const FAQExport: React.FC<FAQExportProps> = ({
  items = [],
  backgroundColor = "#ffffff",
  textColor = "#1f2937",
  accentColor = "#3b82f6",
  borderRadius = 8,
  padding = 16,
  questionFontSize = 16,
  answerFontSize = 14,
  textAlign = "left",
  allowMultiple = false,
}) => {
  const safeItems = Array.isArray(items) ? items : [];
  const actualPadding = padding || 16;
  const actualQuestionFontSize = questionFontSize || 16;
  const actualAnswerFontSize = answerFontSize || 14;

  return (
    <div
      className="faq-container"
      data-allow-multiple={allowMultiple}
      style={{ display: "flex", flexDirection: "column", gap: "12px" }}
    >
      {safeItems.map((item, index) => (
        <div
          key={index}
          style={{
            overflow: "hidden",
            backgroundColor,
            borderRadius: `${borderRadius}px`,
          }}
        >
          <button
            className="faq-toggle"
            style={{
              width: "100%",
              padding: `${actualPadding}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              textAlign: textAlign,
              color: textColor,
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              transition: "background-color 0.2s",
              fontFamily: "inherit",
              fontSize: `${actualQuestionFontSize}px`,
            }}
          >
            <span style={{ fontWeight: 500, paddingRight: "16px", flex: 1, textAlign: textAlign }}>
              {item.question}
            </span>
            <span
              className="faq-icon"
              style={{
                width: "20px",
                height: "20px",
                flexShrink: 0,
                transition: "transform 0.2s",
                color: accentColor,
                fontSize: "1.25rem",
                fontWeight: "bold",
              }}
            >
              +
            </span>
          </button>
          <div
            className="faq-answer"
            style={{
              overflow: "hidden",
              transition: "max-height 0.3s ease",
              maxHeight: 0,
            }}
          >
            <p
              style={{
                paddingLeft: `${actualPadding}px`,
                paddingRight: `${actualPadding}px`,
                paddingBottom: `${actualPadding}px`,
                fontSize: `${actualAnswerFontSize}px`,
                lineHeight: 1.7,
                color: textColor,
                opacity: 0.8,
                margin: 0,
                textAlign: textAlign,
              }}
            >
              {item.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
